import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Bar } from 'react-chartjs-2';
import { DataContext } from '../contexts/DataContext';
import Select from 'react-select';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from 'chart.js';
import moment from 'moment'; // Using moment.js for date manipulation

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
);

const ShipmentsPerWeekChart = () => {
    const { shipments, isLoading } = useContext(DataContext);
    const [chartData, setChartData] = useState({ labels: [], datasets: [] });
    const [timeFrame, setTimeFrame] = useState('monthly');

    useEffect(() => {
        if (!isLoading && shipments && shipments.length > 0) {
            // Function to group data by week or month
            const groupData = (timeFrame, shipments) => {
                return shipments.reduce((acc, shipment) => {
                    const momentDate = moment(shipment.originEtd);
                    const period = timeFrame === 'weekly' ? `${momentDate.year()}-W${momentDate.week()}` : `${momentDate.year()}-M${momentDate.month() + 1}`;
                    const trans = shipment.trans || 'Unknown';

                    if (!acc[period]) {
                        acc[period] = {};
                    }
                    if (!acc[period][trans]) {
                        acc[period][trans] = 0;
                    }
                    acc[period][trans] += 1;

                    return acc;
                }, {});
            };

            // Call the groupData function with the current timeframe
            const dataByTimeFrameAndTrans = groupData(timeFrame, shipments);

            const timeFrames = Object.keys(dataByTimeFrameAndTrans).sort();
            const transTypes = [...new Set(shipments.map(shipment => shipment.trans || 'Unknown'))].sort();
            const dataset = transTypes.map(transType => ({
                label: transType,
                data: timeFrames.map(time => dataByTimeFrameAndTrans[time][transType] || 0),
                backgroundColor: `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.5)`
            }));

            setChartData({
                labels: timeFrames,
                datasets: dataset
            });
        }
    }, [shipments, isLoading, timeFrame]);

    const options = {
        indexAxis: 'y',
        maintainAspectRatio: false, // Disable aspect ratio so we can set a custom height
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            }
        },
        plugins: {
            legend: {
                position: 'bottom',
            },
        },
    };

    const handleTimeFrameChange = selectedOption => {
        setTimeFrame(selectedOption.value);
    };

    const selectOptions = [
        { value: 'weekly', label: 'Weekly' },
        { value: 'monthly', label: 'Monthly' }
    ];

    return (
        <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg flex flex-col justify-between h-auto">            {isLoading ? (
            <div className="flex justify-center items-center h-full">
                <FontAwesomeIcon icon={faSpinner} className="animate-spin text-xl" />
                <span className="ml-2 text-lg">Loading...</span>
            </div>
        ) : (
            <>
                <div className="flex justify-between items-start mb-4">
                    <h2 className="text-lg font-bold text-gray-800 flex items-center">
                        <FontAwesomeIcon icon={faChartBar} className="text-blue-600 mr-2" />
                        Shipments Per {timeFrame === 'weekly' ? 'Week' : 'Month'}
                    </h2>
                    <Select
                        className="w-1/4"
                        value={selectOptions.find(option => option.value === timeFrame)}
                        onChange={handleTimeFrameChange}
                        options={selectOptions}
                        isClearable={false}
                    />
                </div>
                <div className="flex-grow relative" style={{ height: '26rem' }}> {/* This sets the chart height */}
                    <Bar data={chartData} options={options} />
                </div>
            </>
        )}
    </div>
);
};

export default ShipmentsPerWeekChart;